module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "twui-signup"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "twui-signup-body",
    staticStyle: {
      "{ 'min-height'": "minHeight }"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.roleName) + "注册")]), _vm._v(" "), _c('div', {
    staticClass: "twui-bgbox"
  }, [_c('div', {
    staticClass: "twui-astable xinfotip"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "twui-astable-col xinfotip-body"
  }, [_vm._v("以下是" + _vm._s(_vm.roleName) + "注册表单，每项都是必须输入项，提交注册后，将有工作人员对您的信息进行审核，审核通过后将会通过邮件通知您。")])])]), _vm._v(" "), _c('el-form', {
    staticClass: "twui-signup-form"
  }, [_c('el-form-item', {
    attrs: {
      "label": "所选地区:",
      "label-width": "7em"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择地址",
      "options": _vm.options,
      "filterable": ""
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.roleName == '区域管理员'),
      expression: "roleName=='区域管理员'"
    }],
    attrs: {
      "label": "单位名称:",
      "label-width": "7em"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.roleName == '学校管理员'),
      expression: "roleName=='学校管理员'"
    }],
    staticClass: "twui-signup-school"
  }, [_c('el-form-item', {
    attrs: {
      "label": "学校名称:",
      "label-width": "7em"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学校类型:",
      "label-width": "7em"
    }
  }, [_c('div', [_c('el-checkbox', [_vm._v("小学")]), _vm._v(" "), _c('el-radio', {
    staticClass: "twui-xspace-md"
  }, [_vm._v("5年制")]), _vm._v(" "), _c('el-radio', {
    staticClass: "twui-xspace-md"
  }, [_vm._v("6年制")])], 1), _vm._v(" "), _c('div', [_c('el-checkbox', [_vm._v("小学")]), _vm._v(" "), _c('el-radio', {
    staticClass: "twui-xspace-md"
  }, [_vm._v("3年制")]), _vm._v(" "), _c('el-radio', {
    staticClass: "twui-xspace-md"
  }, [_vm._v("4年制")])], 1), _vm._v(" "), _c('div', [_c('el-checkbox', [_vm._v("高中")]), _vm._v(" "), _c('el-radio', {
    staticClass: "twui-xspace-md"
  }, [_vm._v("3年制")])], 1)])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人姓名:",
      "label-width": "7em"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登录邮箱:",
      "label-width": "7em"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号码:",
      "label-width": "7em"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "auto-complete": "off"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "twui-xspace-md",
    staticStyle: {
      "width": "90px"
    },
    attrs: {
      "auto-complete": "off"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "twui-xlink"
  }, [_vm._v("  获取验证码")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登录密码:",
      "label-width": "7em"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "密码至少包含字母、数字、符号中两种，6-20个字符"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码:",
      "label-width": "7em"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系地址:",
      "label-width": "7em"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话:",
      "label-width": "7em"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "7em"
    }
  }, [_c('button', {
    staticClass: "twui-btn xmain xxlarge"
  }, [_vm._v("同意协议并提交")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "7em"
    }
  }, [_c('div', {
    staticClass: "twui-midline"
  }, [_c('a', {
    staticClass: "twui-midline-body twui-xlink"
  }, [_vm._v("《天闻服务协议》")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "z-index": "-1",
      "top": "0",
      "left": "0",
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "id": "particles-js"
    }
  }), _vm._v(" "), _c('tw-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "twui-signup-header"
  }, [_c('img', {
    attrs: {
      "src": "static/dev/images/logo_reg.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("天闻ECO云开放平台")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "twui-astable-col xinfotip-imgbox"
  }, [_c('i', {
    staticClass: "twui-ico xregtip"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-50d42b12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/web/signup.vue
// module id = 595
// module chunks = 1